module.exports = __webpack_public_path__ + "trademark10.png?908171766438b38281607549c5c24f30";


//////////////////
// WEBPACK FOOTER
// ./static/assets/trademark10.png
// module id = 497
// module chunks = 0